import {createSlice} from '@reduxjs/toolkit';
import {loadOpeningDaysExceptions} from './actions';
import {OpeningDaysSliceState} from './types';

const initialState: OpeningDaysSliceState = {
  openingDaysExceptions: [],
  isLoading: false,
};

const slice = createSlice({
  name: 'openingDays',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadOpeningDaysExceptions.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(loadOpeningDaysExceptions.fulfilled, (state, action) => {
        state.openingDaysExceptions = action.payload;
        state.isLoading = false;
      })
      .addCase(loadOpeningDaysExceptions.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export const {reducer: openingDaysReducer} = slice;
